import { B2BCreditCardsFilterType } from '../api/b2b/payments';
export const CreditCardBrands = {
    VISA: 'VISA',
    MA: 'MA',
    AMEX: 'AMEX',
    DISC: 'DISC',
    HDCOM: 'HDCOM',
    HDCON: 'HDCON',
    PROP: 'PROP',
    PROX: 'PROX',
    HDMC: 'HDMC',
    CA_PROX: 'PROX',
    CA_HDCON: 'HDCON',
    CA_HDCOM: 'HDCOM',
    HA: 'HA',
};
export const CreditCardBrandAnalytics = {
    HDCOM: 'hdcom',
    HDCON: 'hdcon',
    PROX: 'prox',
    VISA: 'visa',
    MA: 'mc',
    AMEX: 'amex',
    DISC: 'disc',
    PROP: 'propurch',
    HDMC: '',
    HA: '',
};
export const CreditCardTypes = {
    VISA: 'VI',
    MA: 'MA',
    AMEX: 'AX',
    DISC: 'DS',
    PBA: 'PBA',
    HDCOM: 'HP',
    HDCON: 'HC',
    CRC: 'HR',
    PROP: 'HA',
};
// eslint-disable-next-line no-shadow
export var CreditCardFilterTypes;
(function (CreditCardFilterTypes) {
    CreditCardFilterTypes["VISA"] = "VI";
    CreditCardFilterTypes["MA"] = "MA";
    CreditCardFilterTypes["AMEX"] = "AX";
    CreditCardFilterTypes["DISC"] = "DS";
    CreditCardFilterTypes["HDCOM"] = "HP";
    CreditCardFilterTypes["CRC"] = "HR";
    CreditCardFilterTypes["HDCON"] = "HC";
    CreditCardFilterTypes["PROP"] = "HA";
})(CreditCardFilterTypes || (CreditCardFilterTypes = {}));
export var CreditCardStatusFilterTypes;
(function (CreditCardStatusFilterTypes) {
    CreditCardStatusFilterTypes["ACTIVE"] = "Active";
    CreditCardStatusFilterTypes["INACTIVE"] = "Inactive";
})(CreditCardStatusFilterTypes || (CreditCardStatusFilterTypes = {}));
export const CreditCardStatusFilterMapping = [CreditCardStatusFilterTypes.ACTIVE, CreditCardStatusFilterTypes.INACTIVE];
export const CreditCardTypesTextMapping = {
    [CreditCardFilterTypes.VISA]: 'Visa',
    [CreditCardFilterTypes.MA]: 'Mastercard',
    [CreditCardFilterTypes.DISC]: 'Discover',
    [CreditCardFilterTypes.AMEX]: 'American Express',
    [CreditCardFilterTypes.HDCOM]: 'THD Commercial Account Card',
    [CreditCardFilterTypes.CRC]: 'THD Commercial Revolving Card',
    [CreditCardFilterTypes.HDCON]: 'THD Consumer Credit',
    [CreditCardFilterTypes.PROP]: 'THD Pro Purchase',
};
export const CardBrandFilterValueAnalytics = {
    VI: 'visa',
    MA: 'mastercard',
    AX: 'american express',
    DS: 'discover',
    HP: 'thd commercial account card',
    HR: 'thd commercial revolving card',
    HC: 'thd consumer credit',
    HA: 'thd pro purchase',
    'user entry': 'user entry',
    Active: 'active',
    Inactive: 'inactive',
};
export const FilterByAnalytics = {
    nickName: 'nickname',
    cardBrand: 'card type',
    cardLast4Digits: 'card number',
    status: 'status',
    expDate: 'exp. date',
    citiID: 'citi account id',
    [B2BCreditCardsFilterType.NOTHING]: '',
};
export const MIN_IFRAME_BODY_HEIGHT = 1500;
export const CVV_MIN_LENGTH = 3;
export const CVV_MAX_LENGTH = 4;
export const UnenrollT2CConfirmModalBodyTextCc = `You’ll no longer be able to authorize Remote Purchases using Text2Confirm for this credit card and all Project lines of credit will be unenrolled.`;
export const UnenrollT2CConfirmModalHeaderTextCc = `Do You Want To Stop Text2Confirm Purchase Approvals For This Credit Card?`;
